<template>
    <div id="siteCalibrationHealth" class="baseTemplate">
        <!-- begin:: mobile menu -->
        <app-mobilemenu></app-mobilemenu>
        <!-- end:: mobile menu -->

        <div class="kt-grid kt-grid--hor kt-grid--root">
            <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
                <!-- begin:: home menu -->
                <app-siteconfigurationmenu activeItem="siteCalibrationHealth"></app-siteconfigurationmenu>
                <!-- end:: home menu -->

                <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper">
                    <!-- begin:: header -->
                    <app-header></app-header>
                    <!-- end:: header -->

                    <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                        <!-- begin:: Content Head -->
                        <div class="kt-subheader kt-grid__item">
                            <app-sitetitle subHeaderDescKey="troubleshooting_fingerprintsHealthListSubTitle"></app-sitetitle>
                        </div>
                        <!-- end:: Content Head -->
                        <div
                            class="kt-content kt-grid__item kt-grid__item--fluid"
                        >
                            <!-- begin:: Content -->
                            <div class="row">
                                <div class="col-xl-12">
                                    <div
                                        class="kt-portlet kt-portlet--height-fluid kt-portlet--mobile"
                                    >
                                        <div
                                            class="kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm"
                                        >
                                            <div class="kt-portlet__head-label">
                                                <span class="kt-portlet__head-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                            <rect x="0" y="0" width="24" height="24"/>
                                                            <path d="M19.5,10.5 L21,10.5 C21.8284271,10.5 22.5,11.1715729 22.5,12 C22.5,12.8284271 21.8284271,13.5 21,13.5 L19.5,13.5 C18.6715729,13.5 18,12.8284271 18,12 C18,11.1715729 18.6715729,10.5 19.5,10.5 Z M16.0606602,5.87132034 L17.1213203,4.81066017 C17.7071068,4.22487373 18.6568542,4.22487373 19.2426407,4.81066017 C19.8284271,5.39644661 19.8284271,6.34619408 19.2426407,6.93198052 L18.1819805,7.99264069 C17.5961941,8.57842712 16.6464466,8.57842712 16.0606602,7.99264069 C15.4748737,7.40685425 15.4748737,6.45710678 16.0606602,5.87132034 Z M16.0606602,18.1819805 C15.4748737,17.5961941 15.4748737,16.6464466 16.0606602,16.0606602 C16.6464466,15.4748737 17.5961941,15.4748737 18.1819805,16.0606602 L19.2426407,17.1213203 C19.8284271,17.7071068 19.8284271,18.6568542 19.2426407,19.2426407 C18.6568542,19.8284271 17.7071068,19.8284271 17.1213203,19.2426407 L16.0606602,18.1819805 Z M3,10.5 L4.5,10.5 C5.32842712,10.5 6,11.1715729 6,12 C6,12.8284271 5.32842712,13.5 4.5,13.5 L3,13.5 C2.17157288,13.5 1.5,12.8284271 1.5,12 C1.5,11.1715729 2.17157288,10.5 3,10.5 Z M12,1.5 C12.8284271,1.5 13.5,2.17157288 13.5,3 L13.5,4.5 C13.5,5.32842712 12.8284271,6 12,6 C11.1715729,6 10.5,5.32842712 10.5,4.5 L10.5,3 C10.5,2.17157288 11.1715729,1.5 12,1.5 Z M12,18 C12.8284271,18 13.5,18.6715729 13.5,19.5 L13.5,21 C13.5,21.8284271 12.8284271,22.5 12,22.5 C11.1715729,22.5 10.5,21.8284271 10.5,21 L10.5,19.5 C10.5,18.6715729 11.1715729,18 12,18 Z M4.81066017,4.81066017 C5.39644661,4.22487373 6.34619408,4.22487373 6.93198052,4.81066017 L7.99264069,5.87132034 C8.57842712,6.45710678 8.57842712,7.40685425 7.99264069,7.99264069 C7.40685425,8.57842712 6.45710678,8.57842712 5.87132034,7.99264069 L4.81066017,6.93198052 C4.22487373,6.34619408 4.22487373,5.39644661 4.81066017,4.81066017 Z M4.81066017,19.2426407 C4.22487373,18.6568542 4.22487373,17.7071068 4.81066017,17.1213203 L5.87132034,16.0606602 C6.45710678,15.4748737 7.40685425,15.4748737 7.99264069,16.0606602 C8.57842712,16.6464466 8.57842712,17.5961941 7.99264069,18.1819805 L6.93198052,19.2426407 C6.34619408,19.8284271 5.39644661,19.8284271 4.81066017,19.2426407 Z" fill="#000000" fill-rule="nonzero" opacity="0.3"/>
                                                        </g>
                                                    </svg>
                                                </span>
                                                <h3
                                                    class="kt-portlet__head-title"
                                                >{{ $t("troubleshooting_fingerprintsHealthList") }}</h3>
                                            </div>
                                        </div>
                                        <!--begin emptyList component-->
                                        <app-emptylist targetObjectName="FINGERPRINTSHEALTH_LIST" mainTextKey="troubleshooting_emptyFingerprintsHealth" subTextKey="troubleshooting_emptyFingerprintsHealthSubLabel" imgName="empty_fingerprint.svg" v-bind:isDisplayed="isEmptyList"></app-emptylist>
                                        <!--end emptyList component-->
                                        <div class="kt-portlet__body kt-portlet__body--fit">
                                            <!--begin: Datatable -->
                                            <div class="kt-datatable" id="fingerprintsHealth_datatable"></div>
                                            <!--end: Datatable -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- end:: Content -->
                        </div>
                    </div>

                    <!-- begin:: Footer -->
                    <app-footer></app-footer>
                    <!-- end:: Footer -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import i18n from "../../i18n";
import EmptyList from "./../utils/emptylist.vue";
import SiteTitle from "./../site/widgets/sitetitle.vue";
import moment from "moment";
import commonVueHelper from "../../helpers/commonVueHelper";

export default {
    data() {
        return {
            siteId: this.$route.params.siteId,
            siteFingerprintsHealthTable: null,
            isEmptyList: false
        };
    },
    created: function() {
        console.log("Component(siteFingerprintsHealth)::created() - called");
        // Load user sites from backend and store the result in sites store.
        this.getSiteFingerprintsHealth(this.siteId);
    },
    mounted: function() {
        console.log(
            "Component(siteFingerprintsHealth)::mounted() - Init metronic layout"
        );
        KTLayout.init();
    },
    destroyed: function() {
        console.log("Component(siteFingerprintsHealth)::destroyed() - called");
        this.resetSiteHealthState();
    },
    validations: {
        // -- validations -- List of controls to apply to validate a form.
        // --
    },
    watch: {
        // -- Watch -- Property to perform asynchronous or expensive operations in response to changing component "data".
        // --
        siteFingerprintsHealth: function() {
            console.log("Component(siteFingerprintsHealth)::watch(siteFingerprintsHealth) called");
            this.initKtDataTable();
        },
        user: function(user) {
            if (user) {
                console.log("Component(siteFingerprintsHealth)::watch(user) called with :", user);
                this.initKtDataTable();
            }
        }
    },
    computed: {
        // -- Computed -- Property will only re-evaluate when some of its reactive dependencies have changed.
        // To compose new data from existing datasource
        // To reference a value from the template (cached value)
        // --teAnoth
        ...mapGetters(["siteFingerprintsHealth", "user"])
    },
    methods: {
        // -- Methods -- Property to perform an action.
        // To react on some event happening in the DOM (called every time an event occurs even if method returns the same result)
        // To call a function when something happens in your component (from property "computed" or "watch")
        // ---
        ...mapActions(["getSiteFingerprintsHealth", "resetSiteHealthState"]),

        initKtDataTable() {
            if (this.siteFingerprintsHealth != null) {
                // If site table has been already build, destroy the table before creating a fresh instance !
                if (this.siteFingerprintsHealthTable) {
                    $("#fingerprintsHealth_datatable")
                        .KTDatatable()
                        .destroy();
                }
                // According to source list length, show datatable or empty list icon+text
                if (this.siteFingerprintsHealth.length > 0) {
                    // There is data => Hide empty list icon+text
                    this.isEmptyList = false;

                    // Init source of data in adding some translated attribute to take into account in column sorting
                    const fingerPrintHealthList = this.siteFingerprintsHealth.map((fingerPrintHealth) => {
                        let finalFingerPrintHealth = {...fingerPrintHealth};
                        switch (fingerPrintHealth.status) {
                            case "START":
                                finalFingerPrintHealth.translateStatus = i18n.t("troubleshooting_fingerprintStatusStart");
                                break;
                            case "SUCCESS":
                                finalFingerPrintHealth.translateStatus = i18n.t("troubleshooting_fingerprintStatusSuccess");
                                break;
                            case "FAILURE":
                                finalFingerPrintHealth.translateStatus = i18n.t("troubleshooting_fingerprintStatusFailure");
                                break;
                            default:
                                finalFingerPrintHealth.translateStatus = i18n.t("troubleshooting_fingerprintStatusInterrupted");
                        }
                        return finalFingerPrintHealth;
                    });

                    const options = {
                        data: {
                            type: "local",
                            source: commonVueHelper.preventHtmlInjection(fingerPrintHealthList),
                            pageSize: 20,
                            saveState: {
                                webstorage: false
                            }
                        },
                        layout: commonVueHelper.getLayoutOptions(),
                        translate: commonVueHelper.getTranslateOptions(),
                        toolbar: commonVueHelper.getToolbarOptions(),
                        sortable: true,
                        pagination: true,
                        search: {
                            input: $("#gateways_searchInput")
                        },
                        columns: [
                            {
                                field: "fingerprint",
                                title: i18n.t("troubleshooting_fingerprintNumberLabel"),
                                textAlign: "center",
                                overflow: "visible",
                                autoHide: false
                            },
                            {
                                field: "started",
                                title: i18n.t("troubleshooting_fingerprintStartDateLabel"),
                                textAlign: "center",
                                template: function(row) {
                                    return moment(row.started).format(commonVueHelper.getDateStringFormatFromLocale(moment().locale()));
                                }
                            },
                            {
                                field: "terminated",
                                title: i18n.t("troubleshooting_fingerprintEndDateLabel"),
                                textAlign: "center",
                                template: function(row) {
                                    if (row.terminated) {
                                        return moment(row.terminated).format(commonVueHelper.getDateStringFormatFromLocale(moment().locale()));
                                    } else {
                                        return "-";
                                    }
                                }
                            },
                            {
                                field: "duration",
                                title: i18n.t("troubleshooting_fingerprintDurationDateLabel"),
                                textAlign: "center",
                                sortable: false,
                                template: function(row) {
                                    if (row.duration) {
                                        var duration = "";
                                        if (row.duration.hours > 0) {
                                            if (row.duration.hours === 1) {
                                                duration += row.duration.hours + " " + i18n.t("troubleshooting_fingerprintDurationHour") + " ";
                                            } else {
                                                duration += row.duration.hours + " " + i18n.t("troubleshooting_fingerprintDurationHour") + "s ";
                                            }
                                        }
                                        if (row.duration.minutes > 0) {
                                            if (row.duration.minutes === 1) {
                                                duration += row.duration.minutes + " " + i18n.t("troubleshooting_fingerprintDurationMinute") + " ";
                                            } else {
                                                duration += row.duration.minutes + " " + i18n.t("troubleshooting_fingerprintDurationMinute") + "s ";
                                            }
                                        }
                                        if (row.duration.seconds > 0) {
                                            if (row.duration.seconds === 1) {
                                                duration += row.duration.seconds + " " + i18n.t("troubleshooting_fingerprintDurationSecond");
                                            } else {
                                                duration += row.duration.seconds + " " + i18n.t("troubleshooting_fingerprintDurationSecond") + "s";
                                            }
                                        }
                                        return duration;
                                    } else {
                                        return "-";
                                    }
                                }
                            },
                            {
                                field: "translateStatus",
                                title: i18n.t("troubleshooting_fingerprintStatusLabel"),
                                textAlign: "center",
                                autoHide: false,
                                width: 150,
                                template: function(row) {
                                    if (row.status == "SUCCESS") {
                                        return (
                                            '<span class="kt-badge kt-badge--success kt-badge--dot"></span>&nbsp;<span class="kt-font-bold kt-font-success">' +
                                                row.translateStatus +
                                            "</span>"
                                        );

                                    } else if (row.status == "START") {
                                        return (
                                            '<span class="kt-badge kt-badge--brand kt-badge--dot"></span>&nbsp;<span class="kt-font-bold kt-font-brand">' +
                                                row.translateStatus +
                                            "</span>"
                                        );
                                    } else {
                                        return (
                                            '<span class="kt-badge kt-badge--danger kt-badge--dot"></span>&nbsp;<span class="kt-font-bold kt-font-danger">' +
                                                row.translateStatus +
                                            "</span>"
                                        );
                                    }
                                }
                            }
                        ]
                    };

                    // Now, we are ready to build the table
                    this.siteFingerprintsHealthTable = $(
                        "#fingerprintsHealth_datatable"
                    ).KTDatatable(options);

                } else {
                    // There is no data => Show empty list icon+text
                    // No table process: Comment lines below because table destroy previously
                    this.isEmptyList = true;
                    this.siteFingerprintsHealthTable = null;
                }
            } else {
                this.isEmptyList = true;
            }
        }
    },
    components: {
        // -- Components -- List of local components used in the current template
        // --
        "app-emptylist": EmptyList,
        "app-sitetitle": SiteTitle
    }
};
</script>

<style scoped>
.baseTemplate {
    display: contents;
}
</style>
